import { FOCUSABLE_QUERY_SELECTOR as t } from "../../constants.js";
const n = (o) => {
  const r = o == null ? void 0 : o.querySelectorAll(
    t
  );
  return Array.from(r);
};
export {
  n as focusableElements
};
